<template>        
              
      <div ref="mapContainer" class="a-provider-selector-map" @click="showDateTimePickers = false">

      <div v-show="isLoading" class="loader-bloc">
        <v-progress-linear
          indeterminate        
          color="blue"
        /> 
      </div>  
        

      <div id="searchBloc" class="search-bloc ma-1 not-transparent">
            <v-text-field
              label="Rechercher"
              filled
              rounded
              dense
              :background-color="backgroundColor"
              v-model="searchTags"
            ></v-text-field>

            <v-switch
              v-if="needAcceptance"
              v-model="customPriority"
              inset
              dense
              label="Tous réseaux"
              class="mt-3 ml-4"
              @change="reloadPlaces()"
            ></v-switch>

            <v-btn
              v-if="false"           
              ref="fabAdd"
              fab
              dark
              small
              color="primary"
              @click.stop="onClickFabAddProviderPlace()"
              title="Ajouter un prestataire"
              class="ma-2"
          >
          <v-icon size="20">mdi-plus</v-icon>
          </v-btn>                        

      </div> 

      <div v-if="showCreationBloc" id="creationBloc" class="creation-bloc ma-1">
        <v-card                                
          class="mx-auto my-1 not-transparent"          
          :color="backgroundColor"                                                          
        >     
          <v-card-title>Ajouter un lieu</v-card-title>
          <v-card-text>     
            <v-form>

              <v-select
                v-model="provider"                
                :items="providers"               
                label="Prestataire" 
                :menu-props="{ contentClass: 'provider-select__menu' }"
                return-object
                single-line               
              >      
                <template v-slot:item="{ item }">     
                  <v-list-item
                    ripple   
                    @click="provider = item"                                     
                  >
                    <v-list-item-avatar tile>
                      <v-img :src="item.image"/>                                              
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>                   
                  </v-list-item>
                </template>
              </v-select>
              <v-row>
                <v-col sm="12">
                    <v-text-field                                  
                    label="Nom"                                        
                    dense    
                    ref="providerName"          
                  ></v-text-field>  
                </v-col>  
              </v-row>
              <v-row>
                <v-col sm="12">
                    <v-text-field                                  
                    label="Adresse"                                        
                    dense              
                  ></v-text-field>  
                </v-col>  
              </v-row>
              <v-row>
                <v-col sm="12">
                    <v-text-field                                  
                    label="Complément d'adresse"                                        
                    dense              
                  ></v-text-field>  
                </v-col>  
              </v-row>
              <v-row>
                <v-col sm="4">
                    <v-text-field                                  
                    label="Code postal"                                        
                    dense              
                  ></v-text-field>  
                </v-col>  

                <v-col sm="8">
                    <v-text-field                                  
                    label="Ville"                                        
                    dense              
                  ></v-text-field>  
                </v-col>  
              </v-row>

              <v-row>
                <v-col sm="6">
                    <v-text-field                                  
                    label="Latitude"                                        
                    dense              
                  ></v-text-field>  
                </v-col>  
                
                <v-col sm="6">
                  <v-text-field                                  
                    label="Longitude"                          
                    dense                            
                  ></v-text-field>  
                </v-col>  
              </v-row>
            </v-form>            
             
          </v-card-text>
        </v-card>       
      </div>

      <v-scale-transition>           
        <a-liquid-glass-box
          v-show="resultPlaceSearch.length > 1" id="selectionBloc"
          class="search-result ma-1"
          :opacity="0.6"
          :style="{ '--search-result-selected-bg': selectedBackgroundColor }"
        >
          <v-card                      
            v-for="place in resultPlaceSearch" :key="place.id" 
            class="mx-auto my-1"
            :class="{ 'search-result-card--selected': isSearchResultSelected(place) }"
            :color="backgroundColor"        
            hover   
            @click="onClickSearchPlaceCard(place)"                                  
          >     
            <v-card-text>                 
              <div class="d-flex flex-no-wrap">                          
                <v-avatar
                  size="90"
                  tile
                >
                  <v-img :src="providerImageURL(place.provider)"></v-img>
                </v-avatar>
                <div class="ml-5">      
                  <div class="title">{{place.name}}</div>              
                  <p v-html="formatPlaceAddress(place)"></p>           
                </div>
              </div>  
            </v-card-text>
          </v-card>                
        </a-liquid-glass-box>       
      </v-scale-transition>   

     
      <div id="selectionBloc" class="selection-bloc ma-1" @click.stop> 
         <v-scale-transition>
            <a-liquid-glass-box
              v-if="!onlySelect && selectedPlace !== undefined && resultPlaceSearch.length == 0" 
              width="500px"
              :padding=10
              :opacity="0.6"          
            >          
              <div class="title">Prestataire séléctionné</div>
              <div>
                <div class="d-flex flex-no-wrap">                          
                    <v-avatar
                      size="125"
                      tile
                    >
                        <v-img :src="providerImageURL(selectedPlace.provider)"></v-img>
                  </v-avatar>
                    
                  <div class="ml-5"> 
                  <p class="headline text--primary">
                    {{selectedPlace.name}}
                  </p>
                  <p v-html="formatPlaceAddress(selectedPlace)"></p>           
                  </div>
                </div>  
                            
                <v-chip
                  v-if="proposed.overhaul"
                  class="ml-0 mr-1 my-1"
                  color="teal accent-3"
                  text-color="white"   
                  close   
                  @click:close="proposed.overhaul = false"        
                >
                  <v-avatar left>
                    <v-icon size="18">flaticon-oil</v-icon>
                  </v-avatar>
                  Vidange/Revision
                </v-chip>

                <v-chip
                  v-if="proposed.tires"
                  class="ml-0 mr-1 my-1"
                  color="deep-purple"
                  text-color="white"
                  close
                  @click:close="proposed.tires = false"
                >
                  <v-avatar left>
                    <v-icon size="18">flaticon-tire</v-icon>                  
                  </v-avatar>
                  Pneumatiques {{ tiresOptions }}
                  <v-icon size="18" class="ml-2">{{ tiresSeasonIcon }}</v-icon>
                </v-chip>

                <v-chip
                  v-if="proposed.brakepads"
                  class="ml-0 mr-1 my-1"
                  color="orange darken-3"
                  text-color="white"
                  close
                  @click:close="proposed.brakepads = false"
                >
                  <v-avatar left>
                    <v-icon size="18">flaticon-brake</v-icon>
                  </v-avatar>
                  Plaquettes de freins
                </v-chip>

                <v-chip
                  v-if="proposed.misc"
                  class="ml-0 mr-1 my-1"
                  color="light-blue darken-2"
                  text-color="white"
                  close
                  @click:close="proposed.misc = false"
                >
                  <v-avatar left>
                    <v-icon size="18">flaticon-tools-and-utensils</v-icon>
                  </v-avatar>
                  Divers/Réparation
                </v-chip>          
                
                <div class="subtitle-2 my-2" v-show="needAcceptance">N° d'accord attribué par {{vehicle.lease.provider.name}}</div> 

                <div class="title" v-if="date !== '' && time !== ''">Rendez-vous prévu le {{new Date(`${date} ${time}`).toLocaleString()}}</div>     
              </div>      
              <div class="mt-4">
                <v-btn block color="primary" @click.stop="showDateTimePickers = true">Horaire du rendez-vous</v-btn>
              </div>   
              <div v-if="eBookingAvailable">
                <v-switch
                  v-model="useeBooking"
                  label="Utiliser la prise de rendez-vous en ligne"
                  class="mt-4"
                ></v-switch>
                <v-textarea
                  v-if="useeBooking"
                  v-model="ebookingInfo"
                  label="Informations complémentaires pour la prise de rendez-vous en ligne"
                  filled
                  dense
                  auto-grow
                  rows="2"
                  :background-color="backgroundColor"
                  @input="selectEvent(useeBooking)"
                ></v-textarea>
              </div>   
                                                           
            </a-liquid-glass-box>    
        </v-scale-transition>
        
        <v-scale-transition>
        <a-liquid-glass-box      
          v-if="showDateTimePickers"              
          height="470px"      
          width="400px" 
          :padding=10
          :opacity="0.6"                     
        >
          <div class="title">Date</div>   
          <div>                  
            <v-date-picker      
              first-day-of-week="1"
              flat                        
              v-model="date"    
              full-width                         
              locale="fr-fr"
              :events="functionEvents"
              @change="selectEvent(useeBooking)"                    
            ></v-date-picker>                                                 
          </div>                                                    
        </a-liquid-glass-box>   
        </v-scale-transition>
      
        <v-scale-transition>
        <a-liquid-glass-box      
          v-if="showDateTimePickers"          
          height="470px" 
          width="330px"  
          :padding=10
          :opacity=0.6        
        >            
          <div class="title">Heure</div>   
          <div id="time-picker">
                <v-list v-if="eBookingAvailable && useeBooking" dense style="max-height: 375px;">
                  <v-list-item
                    v-for="slot in displayedTimeslots"
                    :key="slot.startTime"
                    @click="selectTimeslot(slot)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ formatTimeslotLabel(slot) }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="displayedTimeslots.length === 0">
                    <v-list-item-content>
                      <v-list-item-title>Aucun créneau disponible</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-time-picker
                  v-else
                  v-model="time"
                  type="month"
                  format="24hr"
                  full-width
                  :allowed-minutes ="[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]"
                  @change="selectEvent(false)"
                  @click.stop
                ></v-time-picker>
          </div>
        </a-liquid-glass-box>     
        </v-scale-transition>             
      </div>

      <div class="info-bloc ma-0 text-right">                                   
        <div v-if="!onlySelect" text-align="right" class="pa-0">
          <v-chip  
            v-if="vehicle !== undefined && vehicle.lease !== undefined"              
            class="ml-0 mr-1 my-1"
            color="black"
            text-color="white"                                                           
          >                 
            <span class="mr-2">Informations contrat : {{vehicle.lease.provider.name}}</span>
            <v-icon v-if="vehicle.lease.has_maintenance_rent" size="16" color="teal accent-3" class="mx-1">flaticon-oil</v-icon>
            <v-icon v-if="vehicle.lease.has_maintenance_rent" size="16" color="orange darken-3" class="mx-1">flaticon-brake</v-icon>
            <v-icon v-if="vehicle.lease.has_tires_rent" size="16" color="deep-purple" class="mx-1">flaticon-tire</v-icon>
            <v-icon v-if="vehicle.lease.has_other_rent" size="16" color="light-blue darken-2" class="mx-1">flaticon-tools-and-utensils</v-icon>    
          </v-chip>
        </div>

        <div v-if="!onlySelect && services" text-align="right" class="pa-0">
          <v-chip                
            class="ml-0 mr-1 my-1"
            :color="services.overhaul ? 'teal accent-3' : 'grey accent-3'"
            text-color="white"    
            :close="!proposed.overhaul"
            close-icon="mdi-plus-circle" 
            @click:close="proposed.overhaul = true"       
          >
            <v-avatar left>
              <v-icon size="18">flaticon-oil</v-icon>
            </v-avatar>
            Vidange/Revision
          </v-chip>

          <v-chip                
            class="ml-0 mr-1 my-1"
            :color="services.tires ? 'deep-purple' : 'grey accent-3'"                
            text-color="white"
            :close="!proposed.tires"
            close-icon="mdi-plus-circle" 
            @click:close="proposed.tires = true"   
          >            
            <v-icon size="18" left>flaticon-tire</v-icon>                  
            Pneumatiques {{ tiresOptions }}
            <v-icon size="18" class="ml-2">{{ tiresSeasonIcon }}</v-icon>
          </v-chip>

          <v-chip                
            class="ml-0 mr-1 my-1"
            :color="services.brakepads ? 'orange darken-3' : 'grey accent-3'"                
            text-color="white"
            :close="!proposed.brakepads"
            close-icon="mdi-plus-circle" 
            @click:close="proposed.brakepads = true"  
          >
            <v-avatar left>
              <v-icon size="18">flaticon-brake</v-icon>
            </v-avatar>
            Plaquettes de freins
          </v-chip>

          <v-chip                
            class="ml-0 mr-1 my-1"
            :color="services.misc ? 'light-blue darken-2' : 'grey accent-3'"                
            text-color="white"
            :close="!proposed.misc"
            close-icon="mdi-plus-circle" 
            @click:close="proposed.misc = true"
          >
            <v-avatar left>
              <v-icon size="18">flaticon-tools-and-utensils</v-icon>
            </v-avatar>
            Divers/Réparation
          </v-chip>           
          
          <v-chip                
            class="ml-0 mr-1 my-1"
            :color="services.control ? 'yellow darken-2' : 'grey accent-3'"                
            text-color="white"
            :close="!proposed.control"
            close-icon="mdi-plus-circle" 
            @click:close="proposed.control = true"
          >
            <v-avatar left>
              <v-icon size="18">flaticon-car</v-icon>
            </v-avatar>
            Contrôt Technique
          </v-chip>      
        </div>

        <div v-if="!onlySelect && preferences" text-align="right" class="pa-0">
          <v-chip
            v-if="preferences.day1"
            class="ml-0 mr-1 my-1"
            color="green"
            text-color="white"
          >
            Lundi
          </v-chip>
          <v-chip
            v-if="preferences.day2"
            class="ml-0 mr-1 my-1"
            color="green"
            text-color="white"
          >
            Mardi
          </v-chip>
          <v-chip
            v-if="preferences.day3"
            class="ml-0 mr-1 my-1"
            color="green"
            text-color="white"
          >
            Mercredi
          </v-chip>
          <v-chip
            v-if="preferences.day4"
            class="ml-0 mr-1 my-1"
            color="green"
            text-color="white"
          >
            Jeudi
          </v-chip>
          <v-chip
            v-if="preferences.day5"
            class="ml-0 mr-1 my-1"
            color="green"
            text-color="white"
          >
            Vendredi
          </v-chip>
          <v-chip
            v-if="preferences.day6"
            class="ml-0 mr-1 my-1"
            color="green"
            text-color="white"
          >
            Samedi
          </v-chip>
        </div>    

        <div v-if="!onlySelect && localization" text-align="right" class="pa-0">
          <v-chip
            v-if="localization.home"
            class="ml-0 mr-1 my-1"
            color="light-blue lighten-3"
            text-color="white"
            @click="map.setCenter(center)"
          >
            <v-avatar left>
              <v-icon size="18">flaticon-oil</v-icon>
            </v-avatar>
            Proche domicile
          </v-chip> 
        
          <v-chip
            v-if="localization.work"
            class="ml-0 mr-1 my-1"
            color="pink lighten-3"
            text-color="white"
            @click="map.setCenter(center)"
          >
            <v-avatar left>
              <v-icon size="18">flaticon-tire</v-icon>
            </v-avatar>
            Proche lieu de travail
          </v-chip>
        </div>    
      </div>     
    </div>       
  
</template>

<script>
import mapboxgl from 'mapbox-gl';
import constants from '@/js/constants' 
import ALiquidGlassBox from '@/components/ALiquidGlassBox.vue'

const ICON_SIZE = 52
const DEFAULT_PROVIDER_IMAGE = 'independants_64x64.png'

export default {
    name: "AProviderSelector",
    components: { ALiquidGlassBox },
    props: {
      localization: {
        type: Object        
      },
      services: {
        type: Object        
      },
      preferences: {
        type: Object        
      },
      vehicle: {
        type: Object
      },
      onlySelect: {
        type: Boolean,
        default: false
      },
      mapCenter: {
        type: Array
      },
      extra: {
        type: Object        
      },
      ebookingEnabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        id: undefined,
        places: undefined,
        date: '',
        time: '',
        map: undefined,   
        center: [0,0], 
        lastTimeslotCenter: undefined,
        lastTimeslotZoom: undefined,
        markers: [],
        providers:[],
        provider: 0,
        isLoading: false,
        showDateTimePickers: false,
        showCreationBloc: false,
        customPriority: false,
        selectedPlace: undefined,
        selectedMarker: undefined,
        proposed: {...this.services},
        baseURL: constants.application.resourcesURL + '/images/',
        searchTags: '',
        resultPlaceSearch: [],
        backgroundColor: this.$vuetify.theme.dark ? '#00000033' :'#FFFFFFDD',
        selectedBackgroundColor: this.$vuetify.theme.dark ? '#00000099' : '#FFFFFFFF',
        timeoutId: null, 
        useeBooking: false,
        ebookingInfo: ''      
      }
    },
    watch: {
      proposed: function() {
        this.selectEvent(this.useeBooking)
      },
      searchTags: function() {
        if (this.searchTags.length > 3 && this.places !== undefined) { 
          let tags = this.searchTags.replace(/[ -/,]/, ' ').split(' ')
          this.resultPlaceSearch = this.places.filter(el => {              
            for (let i = 0; i < tags.length; i++) {
              if (el.searchString.indexOf(tags[i]) == -1) {
                return false
              }
            }
            return true
          })
          if (this.resultPlaceSearch.length == 1) {
            let center = [this.resultPlaceSearch[0].longitude, this.resultPlaceSearch[0].latitude]
            this.map?.setCenter(center).setZoom(16)
          }               
        }
        else this.resultPlaceSearch = []
      },
      mapCenter: function() {        
          this.center = [...this.mapCenter];
          this.map?.setCenter(this.center);          
      }
    },
    computed: {
      needAcceptance: function() {        
        if (this.vehicle !== undefined && this.vehicle.lease !== undefined) {
          if (this.vehicle.lease.has_maintenance_rent && this.proposed.overhaul || this.proposed.brakepads) return true
          if (this.vehicle.lease.has_tires_rent && this.proposed.tires) return true
          if (this.vehicle.lease.has_other_rent && this.proposed.misc) return true
        }
        return false        
      },
      selectedPlaceHasTimeslots: function() {
        return Array.isArray(this.selectedPlace?.timeslots) && this.selectedPlace.timeslots.length > 0
      },
      displayedTimeslots: function() {
        if (!this.selectedPlaceHasTimeslots) return []
        const selectedDate = this.date ? new Date(this.date) : new Date()
        const now = new Date()
        return this.selectedPlace.timeslots
          .map(slot => ({...slot, start: new Date(slot.startTime)}))
          .filter(slot => slot.start >= now)
          .filter(slot => !selectedDate || slot.start.toDateString() === selectedDate.toDateString())
          .sort((a, b) => a.start - b.start)
      },
      tiresOptions: function() {
        let options = ''
        
        if (this.extra.tires) {
          if (this.extra.tires.front && this.extra.tires.rear) options = 'AV/AR'
          else if (this.extra.tires.front) options = 'AV'
          else if (this.extra.tires.rear) options = 'AR'                    
        }
        return options;
      },
      tiresSeasonIcon: function() {
        if (!this.extra.tires) return ''
        let icon = ''
        if (this.extra.tires.season == 'winter') icon = 'mdi-weather-snowy'
        else if (this.extra.tires.season == 'summer') icon = 'mdi-weather-sunny'
        else if (this.extra.tires.season == 'allSeason') icon = 'mdi-weather-partly-snowy-rainy'  
        console.log(this.extra)
        return icon;      
      },
      eBookingAvailable: function() {
        // Conditions pour eBooking (prise de rdv en ligne) :
        // - eBooking activé dans l'application
        // - Service pneus sélectionné
        // - Le lieu sélectionné doit avoir des créneaux disponibles
        // - Aucun autre service ne doit être sélectionné (car non géré par eBooking)
        return this.ebookingEnabled && this.services.tires && this.selectedPlaceHasTimeslots && this.services.overhaul === false && this.services.brakepads === false && this.services.misc === false && this.services.control === false
      }
    },
    methods: {
      // Méthodes sur évenements
      // -----------------------
      onClickSearchPlaceCard: function(place) {
        if (this.selectedMarker !== undefined) {
          let popup = this.selectedMarker.getPopup()
          if (popup.isOpen()) this.selectedMarker.togglePopup()
        }
        
        this.map?.setCenter([place.longitude, place.latitude]).setZoom(16)
        if (place.marker !== undefined) {
          let popup = place.marker.getPopup()
          if (!popup.isOpen()) place.marker.togglePopup()
        }
        this.selectedMarker = place.marker
      },
      isSearchResultSelected: function(place) {
        return this.selectedMarker !== undefined && this.selectedMarker === place.marker
      },
      onClickMarkerPlace: function(marker, place) {
        this.selectedMarker = marker
        this.selectedPlace = place
        this.resultPlaceSearch = []
        this.searchTags = ''
        this.useeBooking = place.useeBooking
        this.selectEvent(this.useeBooking)
      },
      onClickFabAddProviderPlace: function() {
        this.searchTags = '';
        this.resultPlaceSearch = [];
        this.showCreationBloc = true;
        this.getProviders();
      },
      onClickProvider: function(event) {
        this.$nextTick(() => {
          this.provider = event;
          this.$refs.providerName.$el.focus();
        })
      },
      // Méthodes d'accès aux données
      // ----------------------------
      get: function() {      
        this.isLoading = true;
        let url = `places?vecl=${this.vehicle.id}&${this.needAcceptance && !this.customPriority ? 'renter_priority' : 'customer_priority'}${this.customPriority ? '&all_networks' : ''}` + (this.services.overhaul ? "&overhaul" : '') + (this.services.brakepads ? "&brakepads" : '') + (this.services.tires ? "&tires" : '') + (this.services.misc ? "&misc" : '') + (this.services.control ? "&misc" : '')
        this.$http
            .get(url)            
            .then(response => {                        
                if (response.status == 200) {                
                    this.places = response.data
                    this.places.forEach(element => {
                      const place = `place_${element.id}`
                      element.useeBooking = false
                      const image = element.provider.image ? element.provider.image.toLowerCase() : ''
                      let html = `<h3 class="black--text">${element.name}</h3><span class="black--text">${this.formatPlaceAddress(element)}</span>`
                      if (element.phone != '') html += `</br><span class="black--text"><i class="glyph-icon flaticon-telephone"></i>&nbsp;&nbsp;${element.phone}</span>`
                      if (element.email != '') html += `</br><span class="black--text"><i class="glyph-icon flaticon-email"></i> ${element.email}</span>`
                      
                      element.marker = this.addMarkerOnMap(place, element.longitude, element.latitude, image, ICON_SIZE, html, element)
                      element.searchString = (`#${element.provider.id}# ${element.provider.name} ${element.name} ${element.address1} ${element.address2} ${element.address3} ${element.city} ${element.zip} ${element.phone.replace(/[ -/]/, '')} ${element.email}`).toLowerCase().replace(/[ -/,]/, ' ')
                    });                    
                }        
                if (this.localization.place_id) {
                    let place = this.places.find(el => el.id == this.localization.place_id); 
                    if (place) {
                      this.onClickSearchPlaceCard(place)
                   }
                }   
                this.isLoading = false;                             
            })
            .catch(error => {    
              this.isLoading = false;            
              console.log(error)              
              if (error.response.status === 401) this.$root.$emit("logout"); 
              else this.$root.$emit("serverError", error);     
            });
      },
      getProviders: function() {
        if (this.providers.length === 0) {
          let url = "providers/types/2,4"
          this.$http
              .get(url)            
              .then(response => {                        
                  if (response.status == 200) {
                    this.providers = response.data.map(el => {                   
                      return {
                        value: el.id,
                        text: el.name,                    
                        image: el.image != "" ? `${this.$constants.application.resourcesURL}/images/${el.image}` : "",                    
                      }
                    }) 
                  }                    
              })
              .catch(error => {                              
                  if (error.response.status === 401) this.$root.$emit("logout"); 
                  else this.$root.$emit("serverError", error);     
              })
        }
      },
      
      getTimeslots: function() {                
        const providers = Array.from(new Set((this.places || []).map(el => el.provider?.id).filter(Boolean)))
        const services = Object.keys(this.proposed).filter(key => this.proposed[key])
        const mapCenter = this.map?.getCenter()
        const mapZoom = this.map?.getZoom()
        const position = [
          mapCenter ? mapCenter.lat : this.center[1],
          mapCenter ? mapCenter.lng : this.center[0]
        ]
        const radius = this.getMaxRadiusFromBounds();

        const currentCenter = mapCenter ? { lat: mapCenter.lat, lng: mapCenter.lng } : { lat: this.center[1], lng: this.center[0] }
        if (this.lastTimeslotCenter) {
          const previousLngLat = mapboxgl.LngLat.convert([this.lastTimeslotCenter.lng, this.lastTimeslotCenter.lat])
          const currentLngLat = mapboxgl.LngLat.convert([currentCenter.lng, currentCenter.lat])
          if (previousLngLat.distanceTo(currentLngLat) < radius / 3 && this.lastTimeslotZoom <= mapZoom) return Promise.resolve(null)        
        }
        
        this.lastTimeslotCenter = currentCenter
        this.lastTimeslotZoom = mapZoom


        this.isLoading = true        
        return this.$http
            .post('ebooking/timeslots', {providers, services, position, radius, customer_id: this.vehicle.customer_id})
            .then(response => {
              this.isLoading = false
              if (response.status === 200) {                
                return response.data
              }
              return []
            })
            .catch(error => {    
              this.isLoading = false;            
              console.log(error)              
              if (error.response?.status === 401) this.$root.$emit("logout"); 
              else this.$root.$emit("serverError", error);     
              throw error
            })
      },
      // Méthodes du composant
      // ---------------------
      functionEvents: function(date) {   
        const d = new Date(date)    
        const isPreference = this.preferences[`day${d.getDay()}`] && d >= new Date()
        
        const isSlotAvailable = this.selectedPlace.timeslots?.some(slot => {
          const slotDate = new Date(slot.startTime);
          return slotDate.toDateString() === d.toDateString() && slotDate >= new Date();
        });
        const events = [];
        if (isPreference) events.push('green lighten-1');
        if (isSlotAvailable) events.push('blue darken-1');
        
        return events.length ? events : false;
      },
      providerImageURL: function(provider) {
        const image = provider?.image ? provider.image.toLowerCase() : DEFAULT_PROVIDER_IMAGE
        return `${this.baseURL}${image}`
      },
      formatPlaceAddress: function(place) {
        let address = place.address1.trim()
        if (place.address2 != "" && place.address2 !== null) address += `<br>${place.address2.trim()}`
        if (place.address3 != "" && place.address3 !== null) address += `<br>${place.address3.trim()}`
        address += `<br>${place.zip} ${place.city}`
        return address
      },
      selectEvent: function(isEBooking) {  
        if (this.selectedPlace === undefined) return; 
        this.selectedPlace.isEBooking = isEBooking || false;
        if (this.onlySelect) {
          this.$emit('select', this.selectedPlace);
        }  
        else {           
          let appointment = {
            provider: this.selectedPlace,
            services: this.proposed,
            date: this.date,
            time: this.time,          
            id: this.id,
            ebooking: isEBooking || false,
            ebookingInfo: this.ebookingInfo
          };          
          this.$emit('select', appointment);  
        }      
      },
      selectTimeslot: function(slot) {
        const date = new Date(slot.startTime)
        this.date = date.toISOString().split('T')[0]
        this.time = date.toTimeString().split(' ')[0]
        this.selectEvent(true)
      },
      formatTimeslotLabel: function(slot) {
        const date = new Date(slot.startTime)
        return date.toLocaleString('fr-FR', {
          weekday: 'short',
          day: '2-digit',
          month: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })
      },
      init: function(appointment) {
        this.searchTags = '';
        if (appointment === undefined) {
          this.date = ''
          this.time = ''
          this.selectedPlace = undefined
          this.proposed = {...this.services}   
          this.id = undefined    
          this.ebookingInfo = ''             
        } else {
          const services = Object.values(appointment.services).map(el => el.type_label)
          
          this.proposed = {
            overhaul: services.indexOf('overhaul') != -1,
            tires: services.indexOf('tires') != -1,
            brakepads: services.indexOf('brakepads') != -1,
            misc: services.indexOf('misc') != -1
          }
          
          let date = new Date(appointment.timestamp)           
          this.selectedPlace = appointment.place
          this.date = date.toISOString().split('T')[0]
          this.time = date.toTimeString().split(' ')[0]
          this.id = appointment.id
          this.ebookingInfo = appointment.ebookingInfo || ''

          this.$emit('select', appointment)
        }

        if (this.selectedMarker !== undefined) {
          let popup = this.selectedMarker.getPopup()
          if (popup.isOpen()) this.selectedMarker.togglePopup()
        }
      },
      matchWithPreferences: function(timeslots) {
        return timeslots.some(slot => {
          const date = new Date(slot.startTime);
          const day = date.getDay();          
          return this.preferences[`day${day}`];
        })
      },
      applyTimeslotState: function(timeslots) {
  
        if (!this.places || this.places.length === 0) return              
        timeslots.forEach(slot => {
          const place = this.places.find(p => p.id === slot.place_id)
          if (place) {            
            place.hasTimeslots = slot.timeslots.length > 0
            place.hasExactTimeslots = this.matchWithPreferences(slot.timeslots)
            place.useeBooking = slot.timeslots.length > 0
            place.timeslots = slot.timeslots
            const element = place.marker?.getElement()
            if (element) {
              if (place.hasTimeslots && this.ebookingAvailable) {
                element.classList.add('has-timeslots')
                if (!element.querySelector('.timeslot-label')) {
                  const label = document.createElement('span')
                  label.className = place.hasExactTimeslots ? 'timeslot-label exact' : 'timeslot-label'
                  label.textContent = 'Créneaux disponibles'
                  element.appendChild(label)                  
                }
              } else {
                element.classList.remove('has-timeslots')
                const label = element.querySelector('.timeslot-label')
                if (label) label.remove()
              }
            }            
          }
        })
      },
      refreshTimeslots: function() {
        if (this.ebookingEnabled === false) return
        if (this.timeoutId) clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(async () => {
          try {            
            const timeslots = await this.getTimeslots()            
            if (timeslots) this.applyTimeslotState(timeslots)
          } catch (error) {
            // errors already handled in getTimeslots
          }
        }, 200)
      },
      // Méthodes associé au fonctionnement de la map
      // --------------------------------------------
      addMarkerOnMap: function(name, lng, lat , img, size, popupHTMLContent, onClickElement) {
        // create a DOM element for the marker
        var el = document.createElement('div')
        el.id = name
        el.className = 'marker'

        if (img) {
          const baseURL = constants.application.resourcesURL + '/images/'
          el.style.backgroundImage = `url(${baseURL}${img})`
          el.style.width = size + 'px'
          el.style.height = size + 'px'
          el.style.backgroundSize = 'cover'
        } else {
          // pas de logo prestataire : on reprend le pin SVG par défaut de Mapbox
          el.classList.add('marker--default-pin')
          el.appendChild(new mapboxgl.Marker().getElement().firstChild)
        }

        let marker = new mapboxgl.Marker(el)
            .setLngLat([lng, lat])

        if (popupHTMLContent !== undefined) {
          // create the popup
          var popup = new mapboxgl.Popup({ offset: 25, closeButton: false }).setHTML(popupHTMLContent)                   
          marker.setPopup(popup)          
        }
        
        // add marker to map
        marker.addTo(this.map)              

        if (onClickElement !== undefined) {                       
          el.addEventListener('click', function() {              
              this.onClickMarkerPlace(marker, onClickElement)                                     
          }.bind(this))
        }

        return marker
      },
      reloadPlaces: function() {
        if (this.isLoading) return;
        this.map?.setCenter(this.center)
        this.places?.forEach(place => place.marker.remove())
        this.places = undefined
        this.get();      
      },
      getMaxRadiusFromBounds: function() {
        if (!this.map) return 0
        const bounds = this.map.getBounds()
        const center = mapboxgl.LngLat.convert(this.map.getCenter())
        const corners = [
          bounds.getNorthEast(),
          bounds.getNorthWest(),
          bounds.getSouthEast(),
          bounds.getSouthWest()
        ]

        let maxDistance = 0
        for (let i = 0; i < corners.length; i++) {
          const distance = center.distanceTo(corners[i])
          if (distance > maxDistance) maxDistance = distance
        }
        return maxDistance
      },
      onMapLoad: async function() {
        await this.get()
        if (this.localization) {
          this.addMarkerOnMap('home', this.localization.markers.home.longitude, this.localization.markers.home.latitude, 'home_64x64.png', ICON_SIZE)
          this.addMarkerOnMap('work', this.localization.markers.work.longitude, this.localization.markers.work.latitude, 'work_64x64.png', ICON_SIZE)
        }
        this.refreshTimeslots()
      },
      initMap: function() {
        if (this.$refs.mapContainer) {
          this.$nextTick(() => {    
            let bounds = undefined      
                                  
            if (this.localization) {      
              let lat = this.localization.markers.home.latitude
              let lng = this.localization.markers.home.longitude     

              if (this.localization.home && this.localization.work) {
                lat = (this.localization.markers.home.latitude + this.localization.markers.work.latitude) / 2
                lng = (this.localization.markers.home.longitude + this.localization.markers.work.longitude) / 2     
                
                bounds = [
                  [this.localization.markers.home.longitude, this.localization.markers.home.latitude],
                  [this.localization.markers.work.longitude, this.localization.markers.work.latitude]
                ]
              } else if (this.localization.work) {
                lat = this.localization.markers.work.latitude
                lng = this.localization.markers.work.longitude
              }
              this.center = [lng, lat]
            }

            mapboxgl.accessToken = 'pk.eyJ1IjoiZnNnYXJkIiwiYSI6ImNrODVtanhmcTA3Y3YzZ3BqbXBpaXcwY2EifQ.Q9J9kR1nowA7GThkE7SCWw'
            this.map = new mapboxgl.Map({
                container: this.$refs.mapContainer,
                style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
                center: this.center, // starting position [lng, lat]
                zoom: 14, // starting zoom
                attributionControl: false,
            });      
            if (bounds !== undefined) this.map.fitBounds(bounds, {padding: {top: 100, bottom:100, left: 200, right: 200}})
            if (this.mapCenter) {
              this.center = [...this.mapCenter];
              this.map.setCenter(this.center);   
            }                                    

            this.map.on('moveend', this.refreshTimeslots)
            this.map.on('zoomend', this.refreshTimeslots)
            this.map.on('load', this.onMapLoad)
          })
        }
      }      
    },
    mounted() {   
      this.initMap()                    
    },   
    unmounted() {
      this.map?.off('moveend', this.refreshTimeslots)
      this.map?.off('zoomend', this.refreshTimeslots)
      this.map?.off('load', this.onMapLoad)
      this.map?.remove();
    }
}
</script>

<style lang="scss">
.marker .timeslot-label {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 4px;
  padding: 2px 6px;
  border-radius: 3px;
  background: orange;
  color: white;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid  #b36b00;
}
.marker .timeslot-label.exact {
  background: green;
  border: 1px solid #1d5e1d;
}
</style>

<style lang="scss" scoped>
  

  #time-picker .v-list {
    max-height: 260px;
    overflow-y: auto;
  }
  .a-provider-selector-map { position: relative; top: 0; bottom: 0; height: inherit; width: 100%; margin: 0; padding: 0}
.marker {
  display: block;
  border: none;
  cursor: pointer;
  padding: 0;
  position: relative;
}
.marker.has-timeslots {
  border: 5px solid green !important;
  border-radius: 5px;
  padding-bottom: 20px !important;
}

.loader-bloc {
  position: absolute;  
  top: 0;
  left: 0;  
  width: 100%;  
  z-index: 100;
}
.search-bloc {
  margin-top: 10px;
  position: absolute;  
  display: flex;
  float: left;
  width: 550px;
  z-index: 100;
}
.selection-bloc {    
  display: flex;
  flex-direction: row;
  position: absolute;
  float: left;  
  top: 100px;
  left: 0;
  z-index: 200;
}

.v-card {
  border-radius: 16px;
}

.search-result-card--selected {
  background-color: var(--search-result-selected-bg) !important;
  border-color: var(--search-result-selected-bg) !important;
}

.search-result {  
  position: absolute;
  float: left;
  top: 80px;
  width: 500px;
  overflow-y: scroll;    
  max-height: calc(100% - 110px);
  z-index: 100;
}

.creation-bloc {  
  position: absolute;
  float: left;
  top: 80px;
  width: 500px;
  overflow-y: scroll;      
  z-index: 100;
}

.info-bloc {
  position: relative;
  float: right;  
  z-index: 50;
}

</style>
